import { SxProps, Theme } from '@mui/system'
import { TypographyVariants } from './HomePageText.types'

export const VARIANT_STYLES_MAP: Record<TypographyVariants, SxProps<Theme>> = {
  'display/large': {
    color: '#1F1F1F',
    fontFamily: `'RF Dewi Extended', sans-serif`,
    fontSize: { xs: '2rem', md: '2.75rem', lg: '4rem' },
    fontWeight: 600,
    letterSpacing: '-0.02em',
    lineHeight: { xs: '2.5rem', md: '3.25rem', lg: '4.5rem' }
  },
  'display/regular': {
    color: '#1F1F1F',
    fontFamily: `'RF Dewi Extended', sans-serif`,
    fontSize: { xs: '24px', md: '32px', lg: '48px' },
    fontWeight: 600,
    lineHeight: { xs: '32px', md: '40px', lg: '56px' },
    letterSpacing: '-0.01em'
  },
  'display/small': {
    color: '#1F1F1F',
    fontFamily: `'RF Dewi Extended', sans-serif`,
    fontSize: { xs: '1.125rem', md: '1.5rem', lg: '2rem' },
    fontWeight: 600,
    lineHeight: { xs: '1.5rem', md: '2rem', lg: '2.5rem' }
  },
  'display/mini': {
    color: '#1F1F1F',
    fontFamily: `'RF Dewi Extended', Inter, sans-serif`,
    fontSize: { xs: '16px', md: '20px', lg: '24px' },
    fontWeight: 600,
    lineHeight: { xs: '24px', md: '28px', lg: '32px' }
  },
  'body/large': {
    color: '#53514F',
    fontFamily: `Inter, sans-serif`,
    fontSize: { xs: '1.25rem', md: '1.375rem', lg: '1.5rem' },
    fontWeight: 500,
    letterSpacing: '0.01em',
    lineHeight: { xs: '1.75rem', md: '1.875rem', lg: '2rem' }
  },
  'body/regular': {
    color: '#53514F',
    fontFamily: `Inter, sans-serif`,
    fontSize: { xs: '1rem', lg: '1.125rem' },
    fontWeight: 500,
    letterSpacing: '0',
    lineHeight: { xs: '1.5rem', lg: '1.75rem' }
  },
  'body/small': {
    color: '#53514F',
    fontFamily: `Inter, sans-serif`,
    fontSize: { xs: '0.75rem', md: '0.875rem', lg: '1rem' },
    fontWeight: 500,
    letterSpacing: '0',
    lineHeight: { xs: '1rem', md: '1.375rem', lg: '1.5rem' }
  },
  'body/link': {},
  navbar: {}
}
